import { createContext } from 'react';

// Context for any UI properties of the Diff
export type TabbedDiffUiContextValue = {
  tabbedDiffHeaderHeight: number | undefined;
};

const defaultValues: TabbedDiffUiContextValue = {
  tabbedDiffHeaderHeight: undefined,
};

export const TabbedDiffUiContext = createContext(defaultValues);
